import React, { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { logout } from '../../redux/actions/authActions';
import { Dropdown, Menu, Tooltip } from 'antd';
import { FiChevronDown } from 'react-icons/fi';
import { BsGear } from 'react-icons/bs';
import { TbLogout } from 'react-icons/tb';
import { IoMdArrowDropdown } from 'react-icons/io';
import FdLogo from '../../assets/images/Franchise_logo_header.png';

import './header.style.scss';

const Header = (props) => {
  const auth = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch(logout());
  };
  // const items = [
  //   {
  //     key: '1',
  //     label: (
  //       <span
  //         onClick={() => {
  //           handleLogout();
  //         }}
  //         style={{
  //           cursor: 'pointer',
  //         }}
  //       >
  //         Logout
  //       </span>
  //     ),
  //   },
  // ];

  const dropdownToggle = () => {};
  const profile = auth?.profile;

  const menu = (
    <Menu>
      <Menu.Item
        key='1'
        onClick={() => {
          handleLogout();
        }}
        style={{
          cursor: 'pointer',
        }}
      >
        Logout
      </Menu.Item>
    </Menu>
  );
  return (
    <>
      <div className='row header'>
        <div className='col-md-3'>
          <img
            src={FdLogo}
            //src='https://franchisediscovery.in/img/Franchise-logo.png'
            alt='Franchise World Logo'
          />
          <span
            className='logo-text'
            // onClick={() => {
            //   toast.success('Success');
            // }}
          >
            Franchise <br /> Discovery
          </span>
        </div>
        <div className='col-md-9'>
          <div className='header__right'>
            <div className='header__actions'>
              <div className='username'>
                <p>{`${profile?.firstname || ''} ${
                  profile?.lastname || ''
                }`}</p>
                {/* <IoMdArrowDropdown size={24} /> */}
              </div>
              <div className='header__actions__item'>
                <Tooltip
                  title='Settings'
                  overlayInnerStyle={{
                    backgroundColor: '#285bd1',
                    color: '#ffffff',
                  }}
                >
                  <NavLink to='/settings'>
                    <BsGear size={24} />
                  </NavLink>
                </Tooltip>
              </div>
              <div className='header__actions__item'>
                <Tooltip
                  title='Logout'
                  overlayInnerStyle={{
                    backgroundColor: '#285bd1',
                    color: '#ffffff',
                  }}
                >
                  <button
                    onClick={() => {
                      handleLogout();
                    }}
                  >
                    <TbLogout size={24} />
                  </button>
                </Tooltip>
              </div>
            </div>
          </div>
        </div>
        {/* <div className='col-md-7'></div>
        <div className='col-md-2 position-relative'>

          {auth.user && (
            <Dropdown placement='bottom' overlay={menu}>
              <button
                className={`text-start bg-white border-gray border py-2 w-100 `}
             
              >
                <FiChevronDown
                  size={18}
                  className='fd-font-16 float-end mt-1'
                />
                <p className='text-primary fd-font-14 my-0'>{`${
                  profile?.firstname || ''
                } ${profile?.lastname || ''}`}</p>
              
              </button>
            </Dropdown>
          )}
        </div> */}
      </div>
      {/* <nav className="navbar">
                <NavLink to='demo'>Demo</NavLink>
                {!auth.user && (
                    <NavLink to='/login'> Login </NavLink>
                )}
                {auth.user && (
                    <button type='button' onClick={handleLogout}> Logout </button>
                )}
            </nav> */}
    </>
  );
};

export default Header;
